import styled from 'styled-components';

interface StyledIconProps {
  small?: boolean;
}

export const Container = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.travelDetails.background};
`;

export const Header: any = styled.div`
  display: flex;
  align-items: center;
  padding: 9px 15px 18px 15px;
`;

Header.Avatar = styled.div`
  height: 48px;
  width: 48px;
  border-radius: 100%;
  border: 1px solid ${({ theme }) => theme.userMenu.avatarColor};
`;

Header.Infos = styled.div`
  margin-left: 16px;
  text-align: left;
`;

Header.Infos.Name = styled.span`
  font-weight: bold;
`;

Header.Infos.ViewProfile = styled.span`
  color: ${({ theme }) => theme.userMenu.profileColor};
`;

Header.Done = styled.span`
  font-size: 18px;
  font-weight: bold;
  margin-left: auto;
  color: ${({ theme }) => theme.userMenu.doneColor};
`;

Header.Done = styled.span`
  font-size: 18px;
  font-weight: bold;
  margin-left: auto;
  color: ${({ theme }) => theme.userMenu.doneColor};
`;

export const Icon = styled.img.attrs<any, StyledIconProps>({})`
  width: 36px;
  height: ${({ small }) => (small ? '22px' : '40px')};
`;

export const Logout: any = styled.div`
  width: 100%;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 5;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.userMenu.doneColor};
  cursor: pointer;
`;

export const Subtitle: any = styled.div`
  width: 100%;
  height: 48px;
  background: ${({ theme }) => theme.userMenu.subTitleBackground};
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 4;
  letter-spacing: normal;
  color: ${({ theme }) => theme.userMenu.color};
  padding-left: 41px;
`;
